// const serverURL = "https://api-fleet-management.1now.app";
const serverURL =
  process.env.REACT_APP_ENV !== "dev"
    ? "https://api-fleet-management.1now.app"
    : "https://fleet-management-dev.1now.app";

export default serverURL;
//  export const serverURL = 'http://192.168.100.222:8000';
